import type { DeliveryOption, InStoreDeliveryShippingMethod } from "@jti/commerce";

const getCategoryAttributeFilter = (
  attribute: DeliveryOption["enableStoreFilteringByAttributes"] | undefined
): InStoreDeliveryShippingMethod["categoryAttributeFilter"] => {
  if (!attribute) {
    return undefined;
  }

  if (!attribute || attribute === "both") {
    return "all";
  }

  return attribute;
};

export const transformDeliveryOptionToShippingMethod = (option: DeliveryOption): InStoreDeliveryShippingMethod => {
  return {
    label: option.label,
    type: "in-store delivery" as const,
    description: option.description ?? "",
    methodCode: option.methodCode,
    lat: option.lat ? Number(option.lat) : 0,
    lon: option.lon ? Number(option.lon) : 0,
    defaultZoomLevel: option.defaultZoom ? Number(option.defaultZoom) : 15,
    enableStoreFilteringByAttributes: !!option.enableStoreFilteringByAttributes,
    categoryAttributeFilter: getCategoryAttributeFilter(option?.enableStoreFilteringByAttributes) ?? "all",
    storeLocatorShopDetailsPage: option.storeLocatorShopDetailsPage ?? "",
    filterByCartAvailabilityEnabled: !!option.enableStoreFilteringByAttributes,
    flotiqContentType: option.flotiqContentType ?? "",
    flotiqApiKey: option.flotiqApiKey ?? "",
    openingHoursEnabled: option.openingHoursEnabled ?? false,
    openingHoursBreaksEnabled: option.openingHoursBreaksEnabled ?? false,
    availableSticksEnabled: option.availableSticksEnabled ?? false,
    availableDevicesEnabled: option.availableDevicesEnabled ?? false,
    filtersEnabled: option.filtersEnabled ?? false,
    storeCardAddressEnabled: option.storeCardAddressEnabled ?? false,
    isDefault: option.defaultDelivery,
  };
};
